import store from '@/store'

// 网页可见区域最小宽度
const MIN_WIDTH = 1366

export default {
  beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler)
  },
  mounted() {
  },
  methods: {
    $_resizeHandler() {
      // 网页可见区域宽（包括边框）小于最小宽度，自动隐藏侧边栏
      if (store.getters.appSideBarOpen &&
        document.body.offsetWidth <= MIN_WIDTH) {
        store.commit('app/SET_SIDEBAR_OPEN', false)
        console.log('网页宽度小于1366，自动隐藏侧边栏，数值:' + document.body.offsetWidth)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/resize-handler.js